<template>
  <div class="system-status">
    <el-statistic title="总文章数" :value="stats.total_articles" />
    <el-statistic title="审查通过" :value="stats.passed_articles" class="success-stat" />
    <el-statistic title="审查未通过" :value="stats.failed_articles" class="error-stat" />
    
    <el-divider>系统服务</el-divider>
    <div class="service-list">
      <div class="service-item">
        <span>搜索服务</span>
        <el-tag type="success">正常</el-tag>
      </div>
      <div class="service-item">
        <span>生成服务</span>
        <el-tag type="success">正常</el-tag>
      </div>
      <div class="service-item">
        <span>审查服务</span>
        <el-tag type="success">正常</el-tag>
      </div>
      <div class="service-item">
        <span>链接去重</span>
        <el-tag type="success">正常</el-tag>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import axios from 'axios'

export default {
  name: 'SystemStatus',
  setup() {
    const stats = ref({
      total_articles: 0,
      passed_articles: 0,
      failed_articles: 0
    })

    const fetchStats = async () => {
      try {
        const res = await axios.get('/api/stats')
        stats.value = res.data
      } catch (e) {
        console.error('获取统计失败', e)
      }
    }

    onMounted(() => {
      fetchStats()
    })

    return {
      stats
    }
  }
}
</script>

<style scoped>
.system-status {
  padding: 20px;
}

.service-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.service-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
}

.success-stat :deep(.el-statistic__content) {
  color: #67C23A;
}

.error-stat :deep(.el-statistic__content) {
  color: #F56C6C;
}
</style>
